// @flow
import { combineReducers } from 'redux';
import auth from './auth';

const appReducer = combineReducers({
  auth,
});

const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
